export enum Game {
  DRAG_AND_DROP = 'drag-and-drop',
  PUZZLE = 'puzzle',
  CAROUSSEL = 'caroussel',
  VRAI_FAUX = 'vrai-faux',
  QUI_VEUT_GAGNER = 'qui-veut-gagner',
  JUMP_FORM = 'jump-form',
  STORY = 'story',
  TEXT_A_TROUS = 'text-a-trous',
  ICE_BREAKER = 'ice-breaker',
  POINT_A_RELIER = 'point-a-relier',
  VIDEO_INTERACTIVE = 'video-interactive',
  VIDEO_NODAL = 'video-nodal',
  FROM_THE_SKY = 'from-the-sky',
  PICK_AND_ORDER = 'pick-and-order',
  SHOOT_THEM_UP = 'shoot-them-up',
  DEFFINUM_STORY = 'deffinum-story',
  DEFFINUM_SAYNETE = 'deffinum-saynete',
  SURVEY = 'survey',
  QUIZ_SIMPLE = 'quiz-simple',
}

export const supportedGames = [
  Game.DRAG_AND_DROP,
  Game.PUZZLE,
  Game.CAROUSSEL,
  Game.VRAI_FAUX,
  Game.QUI_VEUT_GAGNER,
  Game.JUMP_FORM,
  Game.TEXT_A_TROUS,
  Game.POINT_A_RELIER,
  Game.VIDEO_INTERACTIVE,
  //Game.SHOOT_THEM_UP,
];

export enum GamePlayerStatus {
  NOT_STARTED = 'not-started',
  STARTED = 'started',
  FINISHED = 'finished',
  FAILED = 'failed',
}

export enum PlayerView {
  INTRO = 'intro',
  GAME = 'game',
  SUMMARY = 'summary',
  COUNTDOWN = 'countdown',
}
